import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/settings/vendor_users/Page";

export const PATH = "/vendors/settings/vendor_users";

const VendorUsersSetting: NextPage = () => (
	<>
		<NskHead title="設定" />
		<Component />
	</>
);

export default VendorUsersSetting;
